import React, { useState } from 'react';
import AppLayout from '../../layout/app.layout';
import ListContentSources from '../../components/content/list-content-sources.component';

const ContentSourcesView = () => {
  const pageTitle = 'Encode Videos / Filmhub';
  const [showFilters, setShowFilters] = useState(false);

  const showFiltersCallback = (val) => {
    setShowFilters(val);
  };

  return (
    <AppLayout pageTitle={pageTitle} showFilter={showFilters}>
      <ListContentSources
        showFilters={showFilters}
        showFiltersCallback={showFiltersCallback}
      />
    </AppLayout>
  );
};

export default ContentSourcesView;
